<div data-cy="tournament-list" class="tournament-list-container">
  <!-- Export Button -->
  @if (paginationResult().totalItems > 0) {
    <div class="export-controls">
      <button
        type="button"
        class="btn btn-sm btn-info"
        (click)="onExportTournaments()"
        title="Export tournaments to CSV"
        >
        <i class="fa fa-file-excel-o"></i> Export to CSV
      </button>
    </div>
  }

  <!-- Tournament Table -->
  <div class="table-responsive">
    @if (paginationResult().totalItems > 0) {
      <table
        class="table table-striped table-hover"
        >
        <thead>
          <tr>
            <th class="col-source-id">
              <app-sortable-header
                column="importSourceId"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Source ID
              </app-sortable-header>
            </th>
            <th class="col-number">
              <app-sortable-header
                column="number"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                #
              </app-sortable-header>
            </th>
            <th class="col-name">
              <app-sortable-header
                column="name"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Tournament Name
              </app-sortable-header>
            </th>
            <th class="col-location">
              <app-sortable-header
                column="city"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Location
              </app-sortable-header>
            </th>
            <th class="col-date">
              <app-sortable-header
                column="startDate"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Start Date
              </app-sortable-header>
            </th>
            <th class="col-date">
              <app-sortable-header
                column="endDate"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                End Date
              </app-sortable-header>
            </th>
            <th class="col-count">
              <app-sortable-header
                column="coursesCount"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Courses
              </app-sortable-header>
            </th>
            <th class="col-count">
              <app-sortable-header
                column="roundsCount"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Rounds
              </app-sortable-header>
            </th>
            <th class="col-count">
              <app-sortable-header
                column="playersCount"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Players
              </app-sortable-header>
            </th>
            <th class="col-status">
              <app-sortable-header
                column="active"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Status
              </app-sortable-header>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (t of paginationResult().items; track t) {
            <tr data-cy="tournament-row">
              <td>{{ t.importSourceId }}</td>
              <td>{{ t.number }}</td>
              <td>
                <a
                  href="javascript:void(0)"
                  (click)="onViewTournament(t)"
                  class="tournament-name-link"
                  >{{ t.name }}</a
                  >
                </td>
                <td>{{ t.city }}</td>
                <td>{{ t.startDate | date : "MM/dd/yyyy" }}</td>
                <td>{{ t.endDate | date : "MM/dd/yyyy" }}</td>
                <td>{{ t.coursesCount }}</td>
                <td>{{ t.roundsCount }}</td>
                <td>{{ t.playersCount }}</td>
                <td>
                  <button
                    class="btn btn-sm"
                    [ngClass]="t.active ? 'btn-primary' : ''"
                    (click)="onToggleTournamentStatus(t)"
                    >
                    <i class="fa" [ngClass]="t.active ? 'fa-check' : 'fa-times'"></i>
                    {{ t.active ? "Active" : "Inactive" }}
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>

    <!-- Pagination Component - Outside of scrollable area -->
    @if (paginationResult().totalItems > 0) {
      <div class="pagination-wrapper">
        <app-table-pagination
          [paginationData]="paginationResult()"
          [itemDescriptor]="'Tournaments'"
          (pageChange)="onPageChange($event.page)"
          >
        </app-table-pagination>
      </div>
    }

    <!-- No Data Messages -->
    @if (paginationResult().totalItems === 0 && _tournaments().length === 0) {
      <div
        class="alert alert-info"
        >
        <i class="fa fa-info-circle"></i> No tournaments found.
      </div>
    }

    @if (paginationResult().totalItems === 0 && _tournaments().length > 0) {
      <div
        class="alert alert-warning"
        data-cy="no-tournaments-message"
        >
        <i class="fa fa-exclamation-triangle"></i> No tournaments match your search
        criteria.
      </div>
    }
  </div>
